export default __webpack_public_path__ + "static/media/ExploreIcon.5b9be9f0.svg";